var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"p-3",attrs:{"span":24,"id":"budgetsImport"}},[_c('el-row',[_c('el-col',{attrs:{"span":22}},[_c('h2',{staticClass:"title mb-4",staticStyle:{"font-weight":"100","display":"inline-block"}},[_vm._v("Welcome!")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":22},domProps:{"innerHTML":_vm._s(_vm.homePageData)}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1808c6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = scs4
// module chunks = 1